/* MM Shipping Countdown – "Vi sender din pakke i dag / i morgen / på mandag"
   Kigger hvert sekund efter alle .mm-ship-cd elementer (også dem der
   bliver sat ind senere via innerHTML, fx i cart draweren). */
(function () {
  if (window.__mmShipCdInit) return;
  window.__mmShipCdInit = true;

  var DAYS_DA = ['s\u00f8ndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'l\u00f8rdag'];

  function cphNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Copenhagen' }));
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function nextTarget(el) {
    var cutoff = (el.getAttribute('data-cutoff') || '16:00').split(':');
    var ch = parseInt(cutoff[0], 10) || 16;
    var cm = parseInt(cutoff[1], 10) || 0;
    var shipDays = (el.getAttribute('data-ship-days') || '1,2,3,4,5')
      .split(',').map(function (d) { return parseInt(d, 10); });

    var now = cphNow();
    for (var i = 0; i < 8; i++) {
      var t = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i, ch, cm, 0);
      var iso = t.getDay() === 0 ? 7 : t.getDay();
      if (shipDays.indexOf(iso) !== -1 && t > now) {
        return { target: t, offset: i };
      }
    }
    return null;
  }

  function dayLabel(offset, target) {
    if (offset === 0) return 'i dag';
    if (offset === 1) return 'i morgen';
    return 'p\u00e5 ' + DAYS_DA[target.getDay()];
  }

  function setText(el, selector, value) {
    var node = el.querySelector(selector);
    if (node && node.textContent !== value) node.textContent = value;
  }

  function tick() {
    var els = document.querySelectorAll('.mm-ship-cd');
    if (!els.length) return;
    var now = cphNow();
    els.forEach(function (el) {
      var info = nextTarget(el);
      if (!info) return;
      var diff = Math.max(0, Math.floor((info.target - now) / 1000));
      var h = Math.floor(diff / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;
      setText(el, '[data-mm-day]', dayLabel(info.offset, info.target));
      setText(el, '[data-mm-h]', pad(h));
      setText(el, '[data-mm-m]', pad(m));
      setText(el, '[data-mm-s]', pad(s));
    });
  }

  tick();
  setInterval(tick, 1000);
  document.addEventListener('cartdrawer:opened', tick);
})();
